<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="Microsoft追加"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <app-table
                  primary-key="menu"
                  :fields="msTb.fields"
                  :items="items"
                  :td-class="cellClass"
                  :tr-class="() => undefined"
                >
                  <!--メニュー-->
                  <template #cell(cloudServiceMenu)="{ item }">
                    {{ $filter.cloudServiceMenuTo(item.cloudServiceMenu)
                    }}<span v-if="item.cloudServiceMenu === 'MS'">(新規)</span>
                  </template>
                  <!--帯域上限値-->
                  <template #cell(bandwidth)="{ item }">
                    {{ $filter.bandwidthTo(item.bandwidth, "Mbps") }}
                  </template>

                  <!--備考-->
                  <template #head(description)>
                    <app-badge
                      item="備考"
                      :isInfo="true"
                      :isRequired="false"
                      :msg="
                        $filter.message(`info_max_length`, { maxLength: 200 })
                      "
                    />
                  </template>

                  <!--備考-->
                  <template #cell(description)="{ item }">
                    <div v-if="item.cloudServiceMenu === 'MS'" class="mt-2">
                      <validation-provider
                        v-model="item.description"
                        label="備考"
                        name="description"
                        :rules="{ required: false, max: { length: 200 } }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-textarea
                          rows="2"
                          v-bind="componentField"
                          :error-messages="errorMessage"
                          :field-meta="meta"
                        />
                      </validation-provider>
                    </div>
                    <template v-else>
                      {{ $filter.emptyTo(item.description, "-") }}
                    </template>
                  </template>
                </app-table>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">設定</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { AppTableHeader } from "@/components/AppTable.vue";
import type { CloudLine, CloudMsPost } from "@/apis/CloudLineApi";

export default defineComponent({
  name: "MicrosoftRegister",
  props: {
    /** 回線番号 */
    enumber: {
      type: String as PropType<string>,
      required: true,
    },
    /** 取得したクラウド回線情報全件 */
    cloudLineList: {
      type: Array as PropType<CloudLine[]>,
      required: true,
    },
    /** クラウド回線排他情報 */
    cloudLineKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      msTb: {
        fields: [
          {
            key: "cloudServiceMenu",
            title: "メニュー",
            width: "140px",
          },
          {
            key: "bandwidth",
            title: "帯域上限値",
            width: "170px",
          },
          {
            key: "description",
            title: "備考",
            width: "200px",
          },
        ] as AppTableHeader<CloudLine>[],
      },
      newMS: {
        cloudServiceMenu: "MS",
        bandwidth: {
          value: 0,
          unit: null,
        },
        description: null,
        note: null,
        cloudLineKeyId: this.cloudLineKeyId,
      } as CloudMsPost,
    };
  },
  computed: {
    items(): (CloudLine | CloudMsPost)[] {
      // 副作用を避けるため、コピー
      const items = [...this.cloudLineList] as (CloudLine | CloudMsPost)[];
      // 既存のMSの後ろにInsert
      let insertIndex =
        items
          .map((v) =>
            v.cloudServiceMenu.startsWith("MS") ? "MS" : v.cloudServiceMenu
          )
          .lastIndexOf("MS") + 1;
      // 既存のMSがない場合、AWSの後ろにInsert
      if (insertIndex === 0) {
        insertIndex =
          items.map((v) => v.cloudServiceMenu).lastIndexOf("AWS") + 1;
      }
      items.splice(insertIndex, 0, this.newMS);
      return items;
    },
  },
  methods: {
    /** Microsoft追加 */
    async submit() {
      await this.$confirm(`Microsoftを追加します。よろしいですか？`);
      await this.$api.cloudLine.postMsCloudLine(this.enumber, this.newMS);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** tdにクラスをつける */
    cellClass(field: AppTableHeader<CloudLine>): string[] | undefined {
      if (field.key === "description") {
        return ["text-pre-wrap"];
      }
      return undefined;
    },
  },
});
</script>
